module.exports = __webpack_public_path__ + "media/Header Video.eb27ca82.mp4";